import React from 'react';
import Modal from '../../component/Inc/Modal';
import LineChart from '../../component/Inc/LineChart';
function PopSaleGoal(props) {
  const {open, close} = props;
  const lineChartWidth = '100%';
  const lineChartHeight = '300px';
  const labels = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];
  const data = {
    lineChartlabels: labels,
    datasets: [
      {
        label: '목표',
        data: [10000, 20000, 40000, 20000, 50000, 20000, 30000, 10000, 20000, 40000, 20000, 50000, 20000, 30000],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#fc8019'
      },
      {
        label: '매출',
        data: [20000, 50000, 30000, 10000, 10000, 20000, 20000, 20000, 60000, 50000, 40000, 20000, 60000, 40000],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#3780ff'
      }
    ]
  };
  return (
    <Modal open={open} close={close} type="pop_sale_goal">
      <h2 className="pop_tit">김담임103 목표설정</h2>
      <div className="content_container scroll">
        <div className="com_chart_wrap">
          <div className="com_calendar_wrap">
            <div className="year ">
              <button className="btn btn_first"></button>
              <button className="btn btn_prev"></button>
              <button className="btn_txt">2023</button>
              <button className="btn btn_next"></button>
              <button className="btn btn_last"></button>
            </div>
          </div>
          <div className="chart_body">
            <div className="chart_name">
              <div className="chart_item">
                <span className="chart_name_label">목표</span>
                <div className="chart_box chart_blue"></div>
              </div>
              <div className="chart_item">
                <span className="chart_name_label">실매출</span>
                <div className="chart_box chart_orange"></div>
              </div>
            </div>
            <div className="chart_content">
              <LineChart data={data} width={lineChartWidth} height={lineChartHeight} />
            </div>
          </div>
        </div>
        <button className="com_btn black xs btn_edit_orange btn_edit_pen_orange">목표 수정하기</button>
        <table className="com_board_list">
          <thead>
            <tr>
              <th>비고</th>
              <th>1월</th>
              <th>2월</th>
              <th>3월</th>
              <th>4월</th>
              <th>5월</th>
              <th>6월</th>
              <th>7월</th>
              <th>8월</th>
              <th>9월</th>
              <th>10월</th>
              <th>11월</th>
              <th>12월</th>
              <th>매출합</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>목표</td>
              <td>
                <input type="text" className="input" defaultValue={`967,999`} />
              </td>
              <td>
                <input type="text" className="input" defaultValue={`967,999`} />
              </td>
              <td>
                <input type="text" className="input" defaultValue={`967,999`} />
              </td>
              <td>
                <input type="text" className="input" defaultValue={`967,999`} />
              </td>
              <td>
                <input type="text" className="input" defaultValue={`967,999`} />
              </td>
              <td>
                <input type="text" className="input" defaultValue={`967,999`} />
              </td>
              <td>
                <input type="text" className="input" defaultValue={`967,999`} />
              </td>
              <td>
                <input type="text" className="input" defaultValue={`967,999`} />
              </td>
              <td>
                <input type="text" className="input" defaultValue={`967,999`} />
              </td>
              <td>
                <input type="text" className="input" defaultValue={`967,999`} />
              </td>
              <td>
                <input type="text" className="input" defaultValue={`967,999`} />
              </td>
              <td>
                <input type="text" className="input" defaultValue={`967,999`} />
              </td>
              <td>9,456,000</td>
            </tr>
            <tr>
              <td>실매출</td>
              <td className="td_point">34,500</td>
              <td className="td_point">234,000</td>
              <td className="td_point">234,000</td>
              <td className="td_red">234,000</td>
              <td className="td_point">234,000</td>
              <td className="td_point">234,000</td>
              <td className="td_point">234,000</td>
              <td className="td_point">234,000</td>
              <td className="td_red">234,000</td>
              <td className="td_point">234,000</td>
              <td className="td_point">234,000</td>
              <td className="td_point">234,000</td>
              <td>9,456,000</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">저장</button>
      </div>
    </Modal>
  );
}

export default PopSaleGoal;
